var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e13737",
    className: "a",
    d: "M18.42,3.37H13.53V2.16A2.16,2.16,0,0,0,11.37,0H8.63A2.16,2.16,0,0,0,6.47,2.16V3.37H1.58A.67.67,0,0,0,.91,4a.66.66,0,0,0,.67.66h.67Q3,11.11,3.76,17.5A2.51,2.51,0,0,0,6.27,20h7.46a2.5,2.5,0,0,0,2.51-2.5Q17,11.1,17.75,4.7h.67A.66.66,0,0,0,19.09,4,.67.67,0,0,0,18.42,3.37ZM7.8,2.16a.83.83,0,0,1,.83-.83h2.74a.83.83,0,0,1,.83.83V3.37H7.8Zm7.11,15.18v.16a1.17,1.17,0,0,1-1.17,1.17H6.27A1.17,1.17,0,0,1,5.1,17.5v-.16l-1-8.55L3.6,4.7H16.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e13737",
    className: "a",
    d: "M10,17.18a.67.67,0,0,0,.67-.67V7A.67.67,0,0,0,9.33,7v9.56A.67.67,0,0,0,10,17.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e13737",
    className: "a",
    d: "M7.33,17.15H7.4A.66.66,0,0,0,8,16.41L7,6.9a.68.68,0,0,0-.74-.59.67.67,0,0,0-.59.74l1,9.5A.68.68,0,0,0,7.33,17.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e13737",
    className: "a",
    d: "M12.6,17.14h.08a.68.68,0,0,0,.66-.6l1-9.5a.67.67,0,0,0-.59-.74A.69.69,0,0,0,13,6.9l-1,9.51A.66.66,0,0,0,12.6,17.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteComment);
export default __webpack_public_path__ + "static/media/delete-comment.b83c216136a5ada842428c65adaacab4.svg";
export { ForwardRef as ReactComponent };